import type { PerformanceDatapointType } from 'owa-analytics-types';
import { markFunction } from './markFunction';
import { calculateBottleneck } from './bottlenecks';

const pendingDatapoints: PerformanceDatapointType[] = [];

export function resolvePendingDatapoints(): void {
    for (const datapoint of pendingDatapoints) {
        datapoint.resolvePendingCallbacks();
    }
}

export function addPendingDatapoint(datapoint: PerformanceDatapointType): void {
    pendingDatapoints.push(datapoint);
}

let pltPromise = Promise.resolve();
/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
 *	> Function markFunction called at module scope is not allowed. This may cause unwanted side effects. */
export const getPltPromise: () => Promise<void> = markFunction(() => pltPromise, 'postren');

export type PltBlocker = 'ribbon' | 'suiteux';

// This function is used to block the PLT
// until the returned callback is called
export function blockPlt(source: PltBlocker) {
    let resolve: () => void;
    const blockingPromise = new Promise<void>(r => {
        resolve = r;
    });
    calculateBottleneck('postren', source, blockingPromise, Date.now());
    pltPromise = pltPromise.then(() => blockingPromise);
    return (): void => {
        resolve?.();
    };
}
